import React from 'react';
import Icon from '../../../components/AppIcon';

const LeadStageCard = ({ stage, count, percentage, color, icon }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border hover:shadow-md transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center"
          style={{ backgroundColor: `${color}20` }}
        >
          <Icon name={icon} size={24} color={color} />
        </div>
        <div className="text-right">
          <div className="text-2xl md:text-3xl font-bold text-foreground font-heading">
            {count}
          </div>
          <div className="text-xs text-muted-foreground font-caption">
            {percentage}%
          </div>
        </div>
      </div>
      <div className="text-sm font-medium text-foreground">
        {stage}
      </div>
      <div className="mt-3 w-full bg-muted rounded-full h-2 overflow-hidden">
        <div 
          className="h-full rounded-full transition-smooth"
          style={{ 
            width: `${percentage}%`,
            backgroundColor: color
          }}
        />
      </div>
    </div>
  );
};

export default LeadStageCard;